import * as Mapping from './mapping';
import * as QA from 'shared/utils/queryAnalysis';
import { areStringsInsensitivelyEqual } from 'shared/utils/utils';


const ColumnType = {
  LeadId: 'leadId',
  Status: 'convertedStatus',
};

const ImportantFields = [ColumnType.LeadId, ColumnType.Status];
  
// const objects = [
  //   { 
  //     leadId: '00Q68000004YY8JEAW', 
  //     convertedStatus: 'Closed - Converted',
  //     contactId: '0036800000DdClsAAF',
  //     contactRecord: { type: 'contact', lastName: 'Speedy gonzales 10', firstName: 'Mother of', email: 'speeedy@gmail.com', department: 'TEST' },
  //     accountId: '0016800000GJs29AAD',
  //     // accountRecord: { type: 'account', id: '0016800000HU1C8AAL', name: 'Gonzales LTD' },
  //     // accountRecord: { type: 'account', name: 'Gonzales LTD UPD' },
  //     // opportunityId: '00668000002X2nVAAS',
  //     // opportunityRecord: { type: 'opportunity', name: 'Gonzales OPP UPD' },
  //     // opportunityName: 'New Opp TEST 2',
  //     opportunityRecord: { type: 'opportunity', name: 'Gonzales OPP UPD 2' },
  //    },
  // ];

export async function applyLeadConversion(excelHeaders, conversion, ctx) {
  const columns = await processColumns(excelHeaders, conversion, ctx);
  const mappings = await processMapping(excelHeaders, conversion, ctx);

  const columnIndexSet = new Set();
  columns.forEach(x => columnIndexSet.add(x.columnData.columnIndex));
  mappings.forEach(x => x.mapping.forEach(y => columnIndexSet.add(y.columnData.columnIndex)));
  const columnIndexes = [...columnIndexSet];

  mappings.forEach(x => Mapping.mapDataColumnIndexes(columnIndexes, x.mapping));
  Mapping.mapDataColumnIndexes(columnIndexes, columns);

  const processRow = (row, rowIndex) => {
    const object = {};
    const errors = [];

    const setValue = (obj, mappedColumn, fieldName) => {
      const { value, error } = Mapping.applyMappedColumnToRow(row, rowIndex, mappedColumn);
      error ? errors.push(error) : obj[fieldName] = value;
    };

    columns.forEach(mappedColumn => {
      const { fieldName } = mappedColumn.columnData;
      setValue(object, mappedColumn, fieldName);
    });
    
    mappings.forEach(completeMapping => {
      const { mapping, constants, objectName, recordFieldName, idFieldName, hasIdField } = completeMapping;

      let recordToModify = object;
      if (!hasIdField) {
        const subRecord = { type: objectName };
        object[recordFieldName] = subRecord;
        recordToModify = subRecord;
      }

      constants.forEach(constant => {
        const { fieldName, value } = constant;
        const fieldOfRecord = hasIdField ? idFieldName : fieldName;
        recordToModify[fieldOfRecord] = value;
      });

      mapping.forEach(mappedColumn => {
        const { name } = mappedColumn.columnData.rawField;
        const fieldOfRecord = hasIdField ? idFieldName : name;
        setValue(recordToModify, mappedColumn, fieldOfRecord);
      });
    });

    return { object, errors };
  }

  return { processRow, columnIndexes, mappings, columns };
}

async function processMapping(excelHeaders, conversion, ctx) {
  const mappings = [];
  const indexesToIgnore = Object.entries(conversion.columnIndexes).reduce((out, x) => {
    const [columnType, columnIndex] = x;
    ImportantFields.includes(columnType) && columnIndex !== null && out.push(columnIndex);
    return out;
  }, []);

  for (const [key, mappingToLoad] of Object.entries(conversion.mappings)) {
    const { sfObjectName: objectName } = mappingToLoad;
    const { mapping, constants, ignoreAllExceptId } = await Mapping.applyMapping(
      excelHeaders, mappingToLoad, { ...ctx, indexesToIgnore, ignoreAllIfIdExists: true }
    );

    if (!mapping.length && !constants.length) {
      continue;
    }
    
    const hasIdField = ignoreAllExceptId;
    const data = hasIdField
      ? { idFieldName: `${key}Id` }
      : { recordFieldName: `${key}Record`, objectName, };
    mappings.push({ ...data, mapping, constants, hasIdField });
  }

  return mappings;
}

async function processColumns(excelHeaders, conversion, ctx) {
  const objectName = QA.KnownObjects.Lead;
  const { columnIndexes } = conversion;
  
  const columnConversion = {
    [ColumnType.LeadId]: QA.KnownFields.Id,
    [ColumnType.Status]: QA.KnownFields.Status,
  };

  return Mapping.loadColumns(excelHeaders, { columnConversion, objectName, columnIndexes }, ctx);
}